/* eslint-disable import/prefer-default-export */
import { ROOT_SLICE_ADMIN } from '../constants';

export const selectRootSliceAdmin = state => state[ROOT_SLICE_ADMIN];
